import { render, staticRenderFns } from "./ExamenFisico.vue?vue&type=template&id=5a0be889"
import script from "./ExamenFisico.vue?vue&type=script&lang=js"
export * from "./ExamenFisico.vue?vue&type=script&lang=js"
import style0 from "./ExamenFisico.vue?vue&type=style&index=0&id=5a0be889&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports